<script>
	
	import formBase from '@_system/components/base/form.vue'
	import boxIndex from './lib/box.vue'
	export default {
		extends: formBase,
		name: 'reconciliationForm',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<box-index ref="finBillBox" title={this.finBillBoxTitle} type={this.finBillBoxType} taskid={this.extra.nodeid} fApi={this.fApi} handle={this.handle} onSubmit={this.submitYFKD} />
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {
				handle:null,
				currentrow:null,
				taskid:0,
				finBillBoxType:'FKD',
				finBillBoxTitle:'未审核付款单'
			}

		},

		watch: {

		},
		computed: {

		},
		created() {
			// if (this.extra.componentname) {
			// 	this.componentname = this.extra.componentname
			// }
		},
		mounted() {

		},
		methods: {
			// beforeSubmit(formData, next) {	
			// 	if (this.extra.nodeid) {
			// 		formData.task_time = this.extra.nodeid[0]
			// 		next()
			// 	}else{
			// 		this.$message.error('请选择日期')
			// 	}
			// },
			addyfkd_reconciliation_pay() {
				this.finBillBoxType = 'YFKD'
				this.finBillBoxTitle = '未审核预付款单'
				this.$refs.finBillBox.modalShow()
				
			},
			regestEvent(){
				if(!this.id){
					this.fApi.setValue('task_time',this.extra.task_time)
				}
			},
			submitYFKD({data}){
				let table = this.fApi.el('$son_reconciliation_pay')
				table.getGrid().insertAt(data, -1)
			},
			tableAdd(e) {
				this.finBillBoxType = 'FKD'
				this.finBillBoxTitle = '未审核付款单'
				this.handle = e
				let supplierid = this.fApi.getValue('wlnid')
				let suppliername = this.fApi.getValue('name')
				if(!supplierid || !suppliername){
					this.$message.error('请选择供应商')
					return
				}
				this.$refs.finBillBox.modalShow()
		
			},
			aftertabledelete(e) {
				switch (e.moduleName) {
					case 'reconciliation_pay':
						this.computeItemAmount()
						break;
				}
				this.computeAmount()
			},
			tablefieldChange(e) {
				switch (e.moduleName) {
					case 'reconciliation_pay':
						this.computeItemAmount()
						
						break;
				}
				this.computeAmount()
			},			
			computeAmount() {
				let table = this.fApi.el('$son_reconciliation_pay')
				let fullData = table.getTableData().fullData
				let amount = 0
				fullData.forEach((item) => {
					amount += !isNaN(parseFloat(item.needamount)) ? parseFloat(item.needamount) : 0

				})
				this.fApi.setValue('amount', amount.toFixed(2))
			},			
			computeItemAmount() {
				let table = this.fApi.el('$son_reconciliation_pay')
				let fullData = table.getTableData().fullData			
				fullData.forEach((item) => {
					let paymentamount = item.paymentamount ? parseFloat(item.paymentamount):0
					let preferential = item.preferential ? parseFloat(item.preferential) : 0
					let tax = item.tax ? parseFloat(item.tax) : 0
					item.needamount = (paymentamount  -  preferential + tax).toFixed(2)
				})			
			},
			
			
			// regestEvent(rule, fApi) {
			// 	console.log(this.extra)
			// 	if (this.extra.nodeid) {
			// 		fApi.setValue('nodeid',this.extra.nodeid)
			// 	}
				
			// },
		},
		components: {
			boxIndex
		}
	}
</script>
